/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { MealReminderResponse } from './MealReminderResponse';

/**
 * A member's meal reminders. Before the first save these are the defaults on offer, with the toggle off.
 */
export type MealRemindersResponse = {
    /**
     * The master toggle. No reminder is sent while it is off.
     */
    enabled: boolean;
    /**
     * Whether reminders are being sent, computed for today in the member's timezone. OFF: the toggle is off or no reminder is on. ACTIVE: inside the current 7-day round. ENDED: the round is over; enabled: true starts a new one.
     */
    status: MealRemindersResponse.status;
    /**
     * The last member-local day of the current or last round, the start day counting as day 1 of 7. Null while the toggle is off.
     */
    activeThrough?: string;
    /**
     * Whether the member's calibration week is over: the 7 member-local days starting on the day of their first meal, whatever their reminders do. False before the first meal.
     */
    calibrationCompleted: boolean;
    /**
     * Whether meal reminders were ever turned on, in the app or through Sophie. Stays true after they are turned off.
     */
    everEnabled: boolean;
    /**
     * The reminders, sorted by time
     */
    reminders: Array<MealReminderResponse>;
};

export namespace MealRemindersResponse {

    /**
     * Whether reminders are being sent, computed for today in the member's timezone. OFF: the toggle is off or no reminder is on. ACTIVE: inside the current 7-day round. ENDED: the round is over; enabled: true starts a new one.
     */
    export enum status {
        OFF = 'OFF',
        ACTIVE = 'ACTIVE',
        ENDED = 'ENDED',
    }


}

